import React from 'react';

import { ShowcaseId } from '@/shared/lib/analytics/showcase';

import { HomeShowcase } from '../HomeShowcase/HomeShowcase';
import { HomeShowcaseSection } from '../HomeShowcaseSection/HomeShowcaseSection';
import { HomeShowcaseHeader } from '../HomeShowcaseHeader/HomeShowcaseHeader';
import { useMultiOfferTab } from '../../hooks/useMultiOfferTab';
import { PaywallSubscriptionInset } from '../PaywallSubscriptionInset/PaywallSubscriptionInset';

interface MultiOfferShowcaseProps {
    className?: string;
}

export const MultiOfferShowcase = ({ className }: MultiOfferShowcaseProps) => {
    const { tabId } = useMultiOfferTab();

    const onboardingShowCaseId =
        tabId === 'extra' ? ShowcaseId.AMEDIATEKA_ONBOARDING : ShowcaseId.ONBOARDING;

    return (
        <HomeShowcaseSection className={className}>
            <HomeShowcase
                id={onboardingShowCaseId}
                header={<HomeShowcaseHeader type="base" />}
                footer={<PaywallSubscriptionInset />}
            />
        </HomeShowcaseSection>
    );
};
